export default __webpack_public_path__ + "static/media/gallery_03.c015fe1a.jpg";